import { createFileRoute } from '@tanstack/react-router';

import { StatusCodesList } from '@/features/status-codes/components/StatusCodesList';

export const Route = createFileRoute('/_auth/status-codes/')({
  component: StatusCodesListPage,
});

/**
 * Status Codes List page — displays all status codes with
 * filter sidebar, pagination, and delete functionality.
 */
function StatusCodesListPage() {
  return (
    <div className="container mx-auto px-6 py-8">
      <StatusCodesList />
    </div>
  );
}
